var map = {
	"./1.mp3": "53c1",
	"./10.mp3": "b0ad",
	"./11.mp3": "fdf8",
	"./12.mp3": "71d1",
	"./13.mp3": "faaa",
	"./14.mp3": "44a0",
	"./15.mp3": "fd7f",
	"./16.mp3": "8161",
	"./17.mp3": "5bcb",
	"./18.mp3": "b8f0",
	"./19.mp3": "2fbf",
	"./2.mp3": "b8ab",
	"./20.mp3": "333f",
	"./21.mp3": "dec6",
	"./22.mp3": "0c55",
	"./23.mp3": "994b",
	"./24.mp3": "e35d",
	"./25.mp3": "f316",
	"./26.mp3": "ffaa",
	"./27.mp3": "fddf",
	"./28.mp3": "ad64",
	"./29.mp3": "895a",
	"./3.mp3": "a9ca",
	"./30.mp3": "830a",
	"./31.mp3": "ee72",
	"./4.mp3": "93b3",
	"./5.mp3": "0926",
	"./6.mp3": "3682",
	"./7.mp3": "a673",
	"./8.mp3": "9bc9",
	"./9.mp3": "ec13"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1724";